/* Land & Light — AJAX cart drawer, free-shipping bar, upsells.
   No dependencies. Progressive enhancement: if anything fails,
   forms still POST to /cart/add and links still go to /cart. */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return; // drawer disabled in theme settings — leave native behavior

  var CURRENCY = drawer.dataset.currency || 'USD';
  var THRESHOLD = parseFloat(drawer.dataset.threshold || '0') * 100; // cents
  var UPSELL_ON = drawer.dataset.upsell === 'true';

  var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY });
  function money(cents) { return fmt.format((cents || 0) / 100); }

  var els = {
    scrim: drawer.querySelector('[data-cart-close]'),
    items: drawer.querySelector('[data-cart-items]'),
    empty: drawer.querySelector('[data-cart-empty]'),
    foot: drawer.querySelector('[data-cart-foot]'),
    subtotal: drawer.querySelector('[data-cart-subtotal]'),
    shipbar: drawer.querySelector('[data-shipbar]'),
    shipMsg: drawer.querySelector('[data-shipbar-msg]'),
    shipFill: drawer.querySelector('[data-shipbar-fill]'),
    upsell: drawer.querySelector('[data-cart-upsell]'),
    upsellItems: drawer.querySelector('[data-upsell-items]'),
    insurance: drawer.querySelector('[data-cart-insurance]')
  };

  // ---- Shipping insurance (auto-added, toggle to remove) ----
  var INS = (function () {
    try {
      var el = document.querySelector('[data-insurance-tiers]');
      var arr = el ? JSON.parse(el.textContent) : [];
      arr.sort(function (a, b) { return a.max - b.max; });
      return arr;
    } catch (e) { return []; }
  })();
  var INS_SHIELD = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5l8-3z"/><path d="M9 12l2 2 4-4"/></svg>';
  function isIns(item) { return item.handle === 'shipping-insurance' || item.product_type === 'Insurance'; }
  function insLineOf(cart) { for (var i = 0; i < cart.items.length; i++) { if (isIns(cart.items[i])) return cart.items[i]; } return null; }
  function realItems(cart) { return cart.items.filter(function (i) { return !isIns(i); }); }
  function realCount(cart) { return realItems(cart).reduce(function (s, i) { return s + i.quantity; }, 0); }
  function subExclIns(cart) { return realItems(cart).reduce(function (s, i) { return s + i.final_line_price; }, 0); }
  function pickTier(cents) {
    var d = cents / 100;
    for (var i = 0; i < INS.length; i++) { if (d <= INS[i].max) return INS[i]; }
    return INS[INS.length - 1];
  }
  function isDeclined(cart) { return !!(cart.attributes && (cart.attributes.insurance_optout === true || cart.attributes.insurance_optout === 'true')); }
  function setDeclined(v) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { insurance_optout: v ? 'true' : '' } })
    }).then(function (r) { return r.json(); });
  }
  function changeRaw(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  // Make the cart's insurance line match the rules. Resolves true if it changed the cart.
  function ensureInsurance(cart) {
    if (!INS.length) return Promise.resolve(false);
    var line = insLineOf(cart);
    if (!realItems(cart).length) { return line ? changeRaw(line.key, 0).then(function () { return true; }) : Promise.resolve(false); }
    if (isDeclined(cart)) { return line ? changeRaw(line.key, 0).then(function () { return true; }) : Promise.resolve(false); }
    var target = pickTier(subExclIns(cart));
    if (!target) return Promise.resolve(false);
    if (!line) return addVariant(target.id, 1).then(function () { return true; });
    if (String(line.variant_id) !== String(target.id) || line.quantity !== 1) {
      return changeRaw(line.key, 0).then(function () { return addVariant(target.id, 1); }).then(function () { return true; });
    }
    return Promise.resolve(false);
  }
  function renderInsurance(cart) {
    if (!els.insurance || !INS.length) return;
    if (!realItems(cart).length) { els.insurance.hidden = true; return; }
    els.insurance.hidden = false;
    var line = insLineOf(cart);
    var insured = !!line;
    var fee = insured ? line.final_line_price : (pickTier(subExclIns(cart)) || {}).fee || 0;
    els.insurance.innerHTML =
      '<div class="ll-ins__icon">' + INS_SHIELD + '</div>' +
      '<div class="ll-ins__txt"><span class="ll-ins__name">Shipping Protection</span>' +
        '<span class="ll-ins__desc">Covers loss, theft &amp; damage in transit</span></div>' +
      '<span class="ll-ins__price">' + money(fee) + '</span>' +
      '<label class="ll-switch" title="Shipping protection"><input type="checkbox" data-insurance-toggle' + (insured ? ' checked' : '') + '><span class="ll-switch__slider"></span></label>';
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ll-no-scroll');
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ll-no-scroll');
  }

  function setCount(n) {
    document.querySelectorAll('.ll-cart-count').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function shipBar(total) {
    if (!els.shipbar || THRESHOLD <= 0) { if (els.shipbar) els.shipbar.hidden = true; return; }
    els.shipbar.hidden = false;
    if (total >= THRESHOLD) {
      els.shipMsg.innerHTML = "You've unlocked <strong>free shipping</strong>! &#127881;";
      els.shipFill.style.width = '100%';
    } else {
      els.shipMsg.innerHTML = "You're <strong>" + money(THRESHOLD - total) + "</strong> away from free shipping";
      els.shipFill.style.width = Math.min(100, (total / THRESHOLD) * 100) + '%';
    }
  }

  function lineItem(item) {
    var li = document.createElement('li');
    li.className = 'll-line';
    li.innerHTML =
      '<img class="ll-line__img" src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '') + '" alt="" width="60" height="60">' +
      '<div class="ll-line__info">' +
        '<a class="ll-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="ll-line__variant">' + item.variant_title + '</div>' : '') +
        '<div class="ll-line__qty">' +
          '<button type="button" class="ll-line__step" data-qty-down data-key="' + item.key + '" aria-label="Decrease">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" class="ll-line__step" data-qty-up data-key="' + item.key + '" aria-label="Increase">+</button>' +
          '<button type="button" class="ll-line__remove" data-remove data-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="ll-line__price">' + money(item.final_line_price) + '</div>';
    return li;
  }

  function render(cart) {
    var real = realItems(cart);
    setCount(realCount(cart));
    var empty = real.length === 0;
    els.empty.hidden = !empty;
    els.foot.hidden = empty;
    els.items.innerHTML = '';
    if (empty) { if (els.upsell) els.upsell.hidden = true; if (els.insurance) els.insurance.hidden = true; shipBar(0); return; }
    real.forEach(function (item) { els.items.appendChild(lineItem(item)); });
    els.subtotal.textContent = money(cart.total_price);
    renderInsurance(cart);
    shipBar(subExclIns(cart));
    if (UPSELL_ON && real[0]) loadUpsell(real[0].product_id, cart);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Sync the insurance line to the rules, then re-render with fresh cart state.
  function syncAndRender() {
    return getCart()
      .then(function (cart) { return ensureInsurance(cart).then(function (changed) { return changed ? getCart() : cart; }); })
      .then(render);
  }
  function refresh() { return syncAndRender(); }

  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeQty(key, qty) {
    return changeRaw(key, qty).then(syncAndRender);
  }

  // ---- Upsell / recommendations ----
  var upsellCache = {};
  function recCard(p, label) {
    var avail = (p.variants || []).filter(function (v) { return v.available; });
    if (!avail.length) avail = (p.variants || []).slice(0, 1);
    if (!avail.length) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';

    // Build a Size picker from the variant options (one color per shirt).
    var sizes = [], vmap = {};
    avail.forEach(function (v) {
      if (v.option1 != null && sizes.indexOf(v.option1) < 0) sizes.push(v.option1);
      vmap[v.option1 || ''] = v.id;
    });
    var picks = sizes.length > 1
      ? '<select class="ll-upsell__opt" data-size>' + sizes.map(function (x) { return '<option>' + x + '</option>'; }).join('') + '</select>'
      : '';

    return '<div class="ll-upsell__item">' +
      '<img src="' + (img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '') + '" alt="" width="48" height="48">' +
      '<div class="ll-upsell__meta"><a href="' + p.url + '">' + p.title + '</a><span>' + money(p.price) + '</span>' + picks + '</div>' +
      '<button type="button" class="ll-upsell__add" data-add="' + avail[0].id + '" data-vmap=\'' + JSON.stringify(vmap) + '\' aria-label="Add ' + p.title + '">Add</button>' +
      '</div>';
  }

  // Normalize a /products.json product into the AJAX shape recCard expects.
  function normalize(p) {
    return {
      id: p.id,
      title: p.title,
      url: '/products/' + p.handle,
      featured_image: (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
      price: Math.round(parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0) * 100),
      variants: (p.variants || []).map(function (v) {
        return { id: v.id, available: v.available !== false, option1: v.option1, option2: v.option2 };
      }),
    };
  }

  function showUpsell(products, inCart) {
    var html = products.filter(function (p) { return !inCart[p.id]; }).slice(0, 3).map(function (p) { return recCard(p); }).join('');
    if (html) { els.upsellItems.innerHTML = html; els.upsell.hidden = false; }
    else { els.upsell.hidden = true; }
  }

  function loadUpsell(productId, cart) {
    if (!els.upsell) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=complementary', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var recs = (d.products || []).filter(function (p) { return !inCart[p.id] && p.handle !== 'shipping-insurance'; });
        if (recs.length) { showUpsell(recs, inCart); return; }
        // Fallback: show other catalog products when no recommendations exist yet.
        return fetch('/products.json?limit=24', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (pd) {
            var pool = (pd.products || []).filter(function (p) { return p.handle !== 'shipping-insurance'; }).map(normalize);
            for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = pool[i]; pool[i] = pool[j]; pool[j] = t; }
            showUpsell(pool, inCart);
          });
      })
      .catch(function () { els.upsell.hidden = true; });
  }

  // ---- Product-page "Complete the look" ----
  function productRecs() {
    var box = document.querySelector('[data-product-recs]');
    if (!box) return;
    var pid = box.dataset.productId;
    var grid = box.querySelector('[data-recs-grid]');
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var products = d.products || [];
        if (!products.length) return;
        grid.innerHTML = products.map(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          return '<a class="ll-card" href="' + p.url + '">' +
            '<div class="ll-card__media"><img src="' + (img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '') + '" loading="lazy" alt=""></div>' +
            '<div class="ll-card__title">' + p.title + '</div>' +
            '<div class="ll-card__price">' + money(p.price) + '</div></a>';
        }).join('');
        box.hidden = false;
      }).catch(function () {});
  }

  // ---- Events ----
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-close]')) { close(); return; }
    if (t.closest('[data-cart-toggle]')) { e.preventDefault(); open(); refresh(); return; }
    var add = t.closest('[data-add]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-add');
      // If this upsell has size/color pickers, resolve the chosen variant.
      var vmapAttr = add.getAttribute('data-vmap');
      var item = add.closest('.ll-upsell__item');
      if (vmapAttr && item) {
        try {
          var vmap = JSON.parse(vmapAttr);
          var sizeSel = item.querySelector('[data-size]');
          var key = sizeSel ? sizeSel.value : '';
          if (vmap[key]) id = vmap[key];
        } catch (err) { /* fall back to default */ }
      }
      add.classList.add('is-loading');
      addVariant(id, 1).then(function () { return setDeclined(false); }).then(refresh).then(open)
        .catch(function () {}).then(function () { add.classList.remove('is-loading'); });
      return;
    }
    var up = t.closest('[data-qty-up]'), dn = t.closest('[data-qty-down]'), rm = t.closest('[data-remove]');
    if (up || dn || rm) {
      var btn = up || dn || rm;
      var key = btn.getAttribute('data-key');
      var line = btn.closest('.ll-line');
      var cur = line ? parseInt(line.querySelector('.ll-line__qty span').textContent, 10) : 1;
      var next = rm ? 0 : (up ? cur + 1 : Math.max(0, cur - 1));
      changeQty(key, next);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  // Intercept any add-to-cart form
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form.matches && form.matches('form[action*="/cart/add"]'))) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var data = new FormData(form);
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
      .then(function () { return setDeclined(false); }).then(refresh).then(open)
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  // Insurance toggle (cart drawer + cart page)
  document.addEventListener('change', function (e) {
    var tg = e.target.closest && e.target.closest('[data-insurance-toggle]');
    if (!tg) return;
    tg.disabled = true;
    setDeclined(!tg.checked).then(syncAndRender).then(function () {
      if (document.querySelector('[data-cart-page]')) location.reload();
      else tg.disabled = false;
    });
  });

  // Init
  if (document.querySelector('[data-cart-page]')) {
    // On the cart page, make the cart correct first; reload once if we changed it
    // so the server-rendered page reflects the insurance line.
    getCart().then(ensureInsurance).then(function (changed) {
      if (changed && !sessionStorage.getItem('ll_ins_reloaded')) {
        sessionStorage.setItem('ll_ins_reloaded', '1');
        location.reload();
      } else {
        sessionStorage.removeItem('ll_ins_reloaded');
        refresh();
      }
    });
  } else {
    refresh();
  }
  productRecs();
  window.LLCart = { open: open, close: close, refresh: refresh, add: addVariant };
})();
